import { createAction, createAsyncThunk } from '@reduxjs/toolkit'

import { NotificationType } from '@/constants/notification-type'
import { Notification, NotificationCount } from '@/model/notification'
import { axios } from '@/utils/axios'

import { createAppAsyncThunk } from './utils'

export const notificationNamespace = 'notification'

export interface ReadAllNotificationsParams {
  creatorId: number
  type: NotificationType
  nextId?: number | undefined
  limit?: number
}

export interface NotificationsResponse {
  list: Notification[]
  hasMore: boolean | undefined
  nextId: number | undefined
}

export const readAllNotifications = createAppAsyncThunk(
  `${notificationNamespace}/readAllNotifications`,
  async ({
    creatorId,
    type,
    nextId,
    limit = 10,
  }: ReadAllNotificationsParams) => {
    const { data } = await axios.get<NotificationsResponse>(
      `/bae/${creatorId}/notification/all`,
      {
        params: {
          nextId,
          limit,
          type,
        },
      },
    )
    return data
  },
)

export const readNotificationCount = createAppAsyncThunk(
  `${notificationNamespace}/readNotificationCount`,
  async ({ creatorId }: { creatorId: number }) => {
    const { data } = await axios.get<NotificationCount>(`/bae/${creatorId}/notification/count`)
    return data
  },
)

export interface MarkNotificationsAsReadParams {
  creatorId: number
  type: NotificationType
}

export const markNotificationsAsRead = createAsyncThunk(
  `${notificationNamespace}/markNotificationsAsRead`,
  async ({ creatorId, type }: MarkNotificationsAsReadParams) => (await axios.post<NotificationCount>(
    `bae/${creatorId}/notification/action/read`,
    {
      type,
    },
  )).data,
)

export interface UpsertNewNotificationParams {
  creatorId: number
  notification: Notification
}
export const upsertNewNotification = createAction<UpsertNewNotificationParams>(`${notificationNamespace}/upsertNewNotification`)